export var HUMO = 1;
export var CARD = 2;
export var EXPAY_SUB_TOKEN_OPTIONS = [
    { value: HUMO, messageId: "recharge.expay.humo" },
    { value: CARD, messageId: "recharge.expay.card" }
];



// WEBPACK FOOTER //
// ./src/constants/expaySubToken.js